import React from 'react';
import styles from './page-container.less';

export const PageContainer: React.FC = ({ children }) => (
    <div className={styles.page}>{children}</div>
);
